import { deleteCookie, getCookie, setCookie } from "../../utils/cookies";
import {
  parseCompanyBrief,
  parseContactId,
  serializeCompanyBrief,
} from "./companyBrief";
import { normalizePermissions } from "./permissions";

export const AUTH_SESSION_CHANGE_EVENT = "auth-session-changed";
export const AUTH_COOKIE_KEYS = [
  "accessToken",
  "refreshToken",
  "userId",
  "userEmail",
  "firstName",
  "lastName",
  "phoneNumber",
  "userRole",
  "userPermissions",
  "contactId",
  "userCompany",
];

export function serializePermissions(permissions) {
  return JSON.stringify(normalizePermissions(permissions));
}

export function parsePermissions(rawPermissions) {
  if (!rawPermissions) return [];

  try {
    return normalizePermissions(JSON.parse(rawPermissions));
  } catch (_error) {
    return [];
  }
}

export function persistAuthUserFields(data) {
  if (!data) return;

  setCookie("accessToken", data.access_token, 1);
  setCookie("refreshToken", data.refresh_token, 7);
  setCookie("userId", data.user_id, 1);
  setCookie("userEmail", data.email, 1);
  setCookie("firstName", data.first_name, 1);
  setCookie("lastName", data.last_name, 1);
  setCookie("phoneNumber", data.phone_number, 1);
  setCookie("userRole", data.role, 1);
  setCookie(
    "userPermissions",
    serializePermissions(data.permissions),
    1,
  );

  const contactId = data.contact_id;
  if (contactId != null && contactId !== "") {
    setCookie("contactId", String(contactId), 1);
  } else {
    deleteCookie("contactId");
  }

  const companySerialized = serializeCompanyBrief(data.company);
  if (companySerialized) {
    setCookie("userCompany", companySerialized, 1);
  } else {
    deleteCookie("userCompany");
  }
}

export function readAuthSession() {
  const accessToken = getCookie("accessToken");
  const contactId = parseContactId(getCookie("contactId"));
  const company = parseCompanyBrief(getCookie("userCompany"));

  const user = {
    id: getCookie("userId"),
    email: getCookie("userEmail"),
    firstName: getCookie("firstName"),
    lastName: getCookie("lastName"),
    phoneNumber: getCookie("phoneNumber"),
    role: getCookie("userRole"),
    permissions: parsePermissions(getCookie("userPermissions")),
    contactId,
    company,
  };

  return {
    accessToken,
    refreshToken: getCookie("refreshToken"),
    contactId,
    company,
    user,
    isAuthenticated: Boolean(accessToken),
  };
}

export function notifyAuthSessionChanged() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(AUTH_SESSION_CHANGE_EVENT));
}

export function clearAuthSessionCookies() {
  AUTH_COOKIE_KEYS.forEach((cookieName) => deleteCookie(cookieName));
}
